exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: -ms-grid;\n  display: grid;\n  width: 100%;\n  -ms-grid-columns: 5rem 1fr;\n      grid-template-columns: 5rem 1fr;\n  grid-template-areas: 'picture info' 'picture content';\n  gap: calc(var(--padding) / 2);\n  margin-bottom: calc(var(--padding)); }\n  :host img {\n    grid-area: picture;\n    width: 5rem;\n    height: 5rem;\n    border-radius: 5px;\n    overflow: hidden;\n    -o-object-fit: contain;\n       object-fit: contain; }\n  :host .info {\n    grid-area: info; }\n  :host .name {\n    font-weight: bold;\n    color: var(--color-primary); }\n  :host .date {\n    font-size: 0.7em; }\n  :host .content {\n    grid-area: content;\n    color: var(--color-primary);\n    margin: 0;\n    padding: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/chat/message/message.component.scss
// module id = ../../../../../src/app/chat/message/message.component.scss
// module chunks = main